import { render } from "./AddressItem.vue?vue&type=template&id=7bcab7ae&scoped=true"
import script from "./AddressItem.vue?vue&type=script&lang=ts"
export * from "./AddressItem.vue?vue&type=script&lang=ts"

import "./AddressItem.vue?vue&type=style&index=0&id=7bcab7ae&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7bcab7ae"

export default script